/**
 * Lightweight shared reading position so sidebar Go To and top Go To stay aligned.
 */

let state = {
  surahId: null,
  currentAyahId: null,
};

const listeners = new Set();

export function getReadingPositionState() {
  return state;
}

export function setReadingPositionState( partial ) {
  state = { ...state, ...partial };
  listeners.forEach((fn) => {
    try {
      fn(state);
    } catch {
      /* ignore */
    }
  });
}

export function subscribeReadingPosition(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
